import _ from 'lodash'
import { combineReducers } from 'redux'
import { reducers } from '@adc/ui-morpheus'
import {
  CLEAR_VENUE_TEMPLATES,
  UPDATE_VENUE_TEMPLATES,
  UPDATE_VENUE_TEMPLATE_IN_LIST,
} from '../../constants/actionTypes'
import { VENUE_TEMPLATES } from '../../constants/tableTypes'
import { apiToUiDataRowTranslation } from '../../translations/venueTemplate'
import tableReducer from './columnDefinitions'

const initialState = {
  content: [],
  total_elements: 0,
}

const venueTemplatesReducer = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_VENUE_TEMPLATES:
      return initialState
    case UPDATE_VENUE_TEMPLATES:
      return Object.assign({}, state, { content: action.venueTemplates })
    case UPDATE_VENUE_TEMPLATE_IN_LIST: {
      const updatedTemplate = apiToUiDataRowTranslation(action.venueTemplate)
      if (
        state.total_elements > 0 &&
        state.content &&
        state.content.length > 0
      ) {
        const matchIndex = _.findIndex(state.content, {
          venue_template_id: updatedTemplate.venue_template_id,
        })
        if (matchIndex > -1) {
          // replace with new updatedTemplate
          return Object.assign({}, state, {
            content: Object.assign([...state.content], {
              [matchIndex]: updatedTemplate,
            }),
          })
        }
        return state
      } else {
        return state
      }
    }
    case `REPLACE_TABLE_USER_INFO_${VENUE_TEMPLATES}`:
      return reducers.dataTable.replaceTableUsersInfoReducer(
        VENUE_TEMPLATES,
        state,
        action
      )
    default:
      return reducers.dataTable.tableFetchReducer(
        VENUE_TEMPLATES,
        state,
        action
      )
  }
}

const venueTemplateDownloadReducer = (state = initialState, action) =>
  reducers.dataTable.downloadFetchReducer(VENUE_TEMPLATES, state, action)

export default combineReducers({
  data: venueTemplatesReducer,
  tableInfo: tableReducer,
  suggestions: (state, action) =>
    reducers.dataTable.suggestionsFetchReducer(VENUE_TEMPLATES, state, action),
  users: (state, action) =>
    reducers.dataTable.mappedUsersReducer(VENUE_TEMPLATES, state, action),
  downloadData: venueTemplateDownloadReducer,
})

export { initialState, venueTemplatesReducer }
